




























import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import userState from '@/store/user';
import Icon from '@/components/common/elements/Icon.vue';
import GlobalNavigation from '@/components/common/elements/GlobalNavigation.vue';
import { sideMenuConfig, MenuObject } from '@/constants/components/sideMenu'
import Logo from '@/components/common/elements/Logo.vue';

@Component({
  components: { Logo, Icon, GlobalNavigation },
})
export default class SideMenu extends Vue {
  private isActive = true;
  private isMenuLabel = true;
  private menuStatus = '';
  private icon = "mdi-menu-open"
  private dropDownList: Array<MenuObject> = []

  mounted(): void {
    this.dropDownList = this.modifyMenu();
  }

  private modifyMenu() {
    let result = sideMenuConfig;
    if (!userState.getIsAdmin){
      result = result.filter(menu => menu.isAdmin === undefined || !menu.isAdmin);
    }
    return result;
  }

  /**
   * サイドメニュー折り畳みアイコン押下時処理
   * @module changeMenu
   * @return {void}
   */
  private changeMenu(): void {
    this.isActive = !this.isActive;
    this.changeStatus();
  }

  /**
   * サイドメニュー折り畳みアイコン押下時付随処理
   * 各メンバの値を変更 (アイコン切り替え、アコーディオンメニューを閉じる、メニューラベルを隠す)
   * @module changeStatus
   * @return {void}
   */
  private changeStatus(): void {
    // this.icon = this.isActive ? "mdi-arrow-left" : "mdi-arrow-right";
    this.isMenuLabel = this.isActive ? true : false;
    this.menuStatus = this.isActive ? "" : "0";
  }
}
